import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=41e00892&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Review.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Review.vue?vue&type=style&index=0&id=41e00892&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e00892",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ReviewLinksList: require('/usr/www/nuxt/components/ReviewLinksList.vue').default,ReviewCollectingContacts: require('/usr/www/nuxt/components/ReviewCollectingContacts.vue').default,ModalBottom: require('/usr/www/nuxt/components/Modal/ModalBottom.vue').default})
